import React, { useState, useEffect } from "react";
import { Box } from "@material-ui/core";

import {
  Typography,
  TextField,
  Button,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Divider,
  ButtonGroup,
  useMediaQuery,
  Menu,
  MenuItem,
} from "@material-ui/core";
import {
  Grid,
  DialogTitle,
  CircularProgress,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  Popover,
} from "@material-ui/core";
import {
  Add,
  DonutSmall,
  VerifiedUser,
  Close,
  MoreVert, Launch, BusinessCenter
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
import Format from "date-fns/format";

import { Skeleton } from "@material-ui/lab";

import Empty from "../../../assets/svg/empty.svg";

import { makeStyles, useTheme } from "@material-ui/styles";

import OperatorDetails from "./operator_details";
import {useGetOrganization} from '../hooks/use_hooks'


import { useCommissions } from "../hooks/use_hooks";

import { AdminService, TransportService,Permissions } from "../../../utils/web_config";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  holder: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: -250,
    },
  },
  tabs: {
    marginTop: -theme.spacing(3),
    marginLeft: -16,
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    marginRight: 10,
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
  logo: {
    borderRadius: 10,
  },
}));



function CentrikaView(props) {
  const classes = useStyles();
  const history = useHistory();

  const getOrganization =useGetOrganization({id:history.location?.state?.organization_id})

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));
  const [menuOpen, setMenuOpen] = useState(null);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [accountData, setAccountData] = useState({});

  const [button, setButton] = useState(0)
  // const commissions = usecommissions({
  //   id: history.location.state.organization_id,
  // });
  const allCommissions = useCommissions();

  const [licenses, setLicenses] = useState({
    status: "loading",
    loading: false,
    saving: false,
    open: false,
    data: [],
  });
  const [commissions, setCommissions] = useState({
    status: "loading",
    loading: false,
    saving: false,
    open: false,
    data: [],
  });

  const [operators, setOperators] = useState({
    loading2: false,
  })





  const [operator, setOperator] = useState({});

  const [commissionChannelType, setChannelType] = useState({
    value: "",
    error: "",
  });
  const [commissionCommission, setCommission] = useState({
    value: "",
    error: "",
  });
  const [commissionDiscount, setDiscount] = useState({ value: "", error: "" });

  const [licenseIssueDate, setIssueDate] = useState({
    value: new Date(),
    error: "",
  });
  const [licenseExpiryDate, setExpiryDate] = useState({
    value: new Date(),
    error: "",
  });
  const [licenseLicenseNumber, setLicenseNumber] = useState({
    value: "",
    error: "",
  });

  const [licenseRoutes, setRoutes] = useState({ data: [] });

  const [licenseOrigin, setLicenseOrigin] = useState({
    value: "",
    error: "",
  });

  const [licenseDestination, setLicenseDestination] = useState({
    value: "",
    error: "",
  });

  useEffect(() => {
    setOperator(history.location.state);
    var accountData = new AdminService().accountData;
    setAccountData(accountData);

  }, []);



  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };


  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={classes.root}>
        {/* Dialogs ends here */}
        <Grid container spacing={2} justify='center'>


          <Grid item xs={12} md={6}>

            <OperatorDetails data={history.location.state} logo={getOrganization?.data?.logo_file_byte}/>
          </Grid>
        </Grid>

      </div>
    </MuiPickersUtilsProvider>
  );
}


export default withLocalize(CentrikaView);
